var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Cart',{attrs:{"cart":_vm.cart},on:{"remove-from-cart":_vm.handleRemoveFromCart,"empty-cart":_vm.handleEmptyCart,"checkout":_vm.handleNavigateTocheckout,"refresh-cart":_vm.refreshCart}})
}
var staticRenderFns = []

export { render, staticRenderFns }